import Navigation from "../../header";
import { Container } from "@mui/material";
import { PowerBIEmbed } from 'powerbi-client-react';
import { IEmbedConfiguration, models } from 'powerbi-client';
import PermissionGate from "../../permissionGate";
import { useUserContext } from "../../../contexts/userContext";

const SummaryReport = () => {
	const userContext = useUserContext();

	return (
		<>
			<Navigation></Navigation>
			<Container maxWidth="lg" className="route-container">
				<PermissionGate permission={userContext?.permissions?.canViewReportSummary}>
					<h1 className="report-header">Customer Summary Report</h1>
					{/* <iframe role="presentation" width="1200" height="800" src="https://app.powerbi.com/rdlEmbed?reportId=9787d12f-b731-486f-808e-93d83670d2ca&autoAuth=true&ctid=3d903043-2b47-4eb6-ba60-a27fe7950ef2&experience=power-bi" frameBorder="1"></iframe> */}
					<embed width="1200" height="800" src="https://app.powerbi.com/rdlEmbed?reportId=9787d12f-b731-486f-808e-93d83670d2ca&autoAuth=true&ctid=3d903043-2b47-4eb6-ba60-a27fe7950ef2&experience=power-bi">
					</embed>
				</PermissionGate>
			</Container>
		</>
	);
};

export default SummaryReport;